import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useCancelBookingMutationV2 } from 'reservations/cancel/queries/useCancelBookingMutationV2';

export const LeaveWaitlistModal = () => {
  const cancelMutation = useCancelBookingMutationV2();

  return (
    <BaseDrawer
      header="LEAVE WAITLIST"
      subheader="Are you sure you want to leave the waitlist?"
      primaryButton={{
        label: 'LEAVE WAITLIST',
        onClick: cancelMutation.mutate
      }}
      secondaryButton={{}}
      bookingDetailsDisplay="strikethrough"
      requireAuth
    />
  );
};
